// src/component/APIs/MessageHandler.js

import rh from '@/components/APIs/RequestHandler'

class MessageHandler {
  errors = []

  test () {
    alert('test method')
  }

  async formatMessage (message) {
    var formattedMessage = ''
    if (message) {
      formattedMessage = JSON.parse(JSON.stringify(message))
      var body = { 'key': message }
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_MESSAGE}/format-message`
      var postResponse = await rh.post(endpoint, body, true).catch(e => {
        this.errors.push(e)
      })
      // console.log(postResponse)
      formattedMessage = !postResponse.data.formattedMessage ? postResponse.data.message : postResponse.data.formattedMessage
      // console.log(formattedMessage)
    }
    return formattedMessage
  }
}

export default new MessageHandler()
